const refactorRespImg = (img, sizes) => {
  if (!img) {
    return null;
  }

  const sizeObj = {};

  sizes.forEach(({ size, key }) => {
    const [width, height] = key.split('_').pop().split('x');
    sizeObj[size] = {
      width : width || '',
      height : height || '',
      png: img.sourceUrl ? `${img.sourceUrl}?format=png&width=${width}&quality=75` : null,
      jpg: img.sourceUrl ? `${img.sourceUrl}?format=jpg&width=${width}&quality=75` : null,
      webp: img.sourceUrl ? `${img.sourceUrl}?format=auto&width=${width}&quality=75` : null,
    }
  });

  if (!sizeObj.default && Object.keys(sizeObj).length > 0) {
    sizeObj.default = sizeObj[Object.keys(sizeObj)[0]];
  }

  return {
    alt: img.altText || '',
    sizes: sizeObj,
    allSizes: [],
    original: img.sourceUrl ? img.sourceUrl.replace('.png', '.webp') : null,
    placeholderSrc: img.sourceUrl ? `${img.sourceUrl}?format=auto&quality=10` : null,
  }
}

export default refactorRespImg
